import Button from "components/bootstrap/Button";
import Card from "components/bootstrap/Card";
import Input from "components/bootstrap/forms/Input";
import InputGroup from "components/bootstrap/forms/InputGroup";
import Modal, { ModalBody, ModalHeader } from "components/bootstrap/Modal";
import Icon from "components/icon/Icon";
import { useMst } from "models";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CompanyService from "services/CompanyService";
import AlarmService from "services/AlarmService";
import AddCompanyModal from "./AddCompanyModal";
import JoinCompanyModal from "./JoinCompanyModal";
import ThemeContext from "contexts/themeContext";
import {Configs} from '../../../../models/Configs';
import BoardService from '../../../../services/BoardService';
import { useNavigate } from "react-router-dom";
import BackgroundSetContent from "./BackgroundSetContent";
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from "components/bootstrap/Dropdown";
import LANG from "lang";
import { useChangeLanguage } from "helpers/locales";
import imgNoData from '../../../../assets/img/deadline/img_no_list.png';
import useDarkMode from "hooks/useDarkMode";
import { getSnapshot } from "mobx-state-tree";
import showNotification from "components/extras/showNotification";
import Label from "components/bootstrap/forms/Label";

/******************************************************************
 * 파일명 : frontend2\src\pages\common\Headers\components\SettingModal.js
 * 설명 : 상단 util 영역 > 설정 모달
 ******************************************************************/

const SettingModal = ({
    isSettingPopOpen,
    setIsSettingPopOpen
}) => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState('company');
    const [myCompanies, setMyCompanies] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [appliedSearchText, setAppliedSearchText] = useState('');
    const [companyModal, setCompanyModal] = useState(false);
    const [companyModal2, setCompanyModal2] = useState(false);
    const {setNoticeCount, mobileDesign, lang} = useContext(ThemeContext);
    const navigate = useNavigate();
    const tabList = [
        {menuName:'company', label:t('회사 변경'), icon:'Building'},
        {menuName:'background', label:t('배경 이미지'), icon:'FileImage'},
        {menuName:'language', label:t('언어'), icon:'Globe'},
        {menuName:'theme', label:t('테마'), icon:'Moon'},
    ]
    const {company, user} = useMst();

    /////// 탭1: 회사변경 관련 --s
    // 회사 변경 관련 데이터
    const getCompany = async () => {
        try {
            const myCompanyList = await CompanyService.myCompany();
            if (myCompanyList.data) setMyCompanies([...myCompanyList.data]);
        } catch(error) {
            console.error('회사 목록 조회 실패', error);
        }
    };

    useEffect(() => {
        getCompany();
    }, [isSettingPopOpen]);

    const selectedCompanyId = company?.id;
    const selectedCompany = myCompanies.find((v) => v.id === selectedCompanyId); // 현재 회사
    const otherCompany = myCompanies.filter((v) => v.id !== selectedCompanyId); // 전환 가능 회사
    const filteredCompany = otherCompany.filter((v) => v.name?.toLowerCase().includes(appliedSearchText.trim().toLowerCase())); // 회사명으로 필터된 회사

    const handleOnClickToEmployeeListPage = async (companyInfo) => {
		if(companyInfo.state === 'LEAVE'){
			showNotification(t('회사 변경'), t('접속할 수 없는 회사입니다.'), 'danger');
			return;
		}

		await company.selectCompany(companyInfo.id, mobileDesign);

		if (companyInfo.state === 'SUCCESS') {
			Configs.setAdminMode(companyInfo.isAdmin);
			const res = await BoardService.readCount('notice', companyInfo.id);
			setNoticeCount(res?.data || 0);

			await user.authMe()
			navigate('/');
		} else if (companyInfo.state === 'REQUEST') {
			showNotification(t('회사 변경'), t('회사 참여 승인 대기중입니다'), 'info');
		}
	};
    /////// 탭1: 회사변경 관련 --e

    /////// 탭3: 언어 관련 --s
    const { updateLanguage } = useChangeLanguage();
    const changeLanguage = async (lng) => {
        updateLanguage(lng);
        try {
            // 알림 문구 언어 저장 (BE는 중국어를 'zh'로 받음)
            await AlarmService.alarmSettingLangModify(lng === 'ch' ? 'zh' : lng);
        } catch(error) {
            console.error('언어 설정 저장 실패', error);
        }
    };
    const currentLang = Object.values(LANG).find((item) => item.lng === lang); // 현재 언어
    /////// 탭3: 언어 관련 --e

    /////// 탭4: 테마 관련 --s
    const {darkModeStatus, setDarkModeStatus} = useDarkMode();

    const THEME = {
        LIGHT: {key:'light', text:t('라이트'), icon:'Sun'},
        DARK: {key:'dark', text:t('다크'), icon:'Moon'}
    }

    const currentTheme = Object.values(THEME).find(
        (item) => item.key === (darkModeStatus ? 'dark' : 'light')
    );

    const changeTheme = (key) => {
        setDarkModeStatus(key === 'dark');
    };
    /////// 탭4: 테마 관련 --e

    useEffect(() => {
        if (isSettingPopOpen) {
            setSelectedTab('company'); // 기본으로 회사 변경 탭이 active 된 상태로 모달 오픈
        }
    }, [isSettingPopOpen]);

    return (
        <>
        <Modal
            modalClassNameProps='setting_modal'
            classNameProps='type_tab'
            isOpen={isSettingPopOpen}
            size="xl"
            isCentered
            isStaticBackdrop
        >
            <ModalHeader setIsOpen={setIsSettingPopOpen} />
            <ModalBody>
                <div className="left_area">
                    <div>
                        <div className="tit_box">
                            <h2>{t('설정')}</h2>
                            <p>{t('메타타임 개인 환경을 설정합니다.')}</p>
                        </div>
                        {/* 메뉴 */}
                        <ul className="tab_menu">
                            {tabList.map((tab) => {
                                return(
                                    <li key={tab.menuName}>
                                        <Button
                                            type='button'
                                            icon={tab.icon}
                                            className={selectedTab === tab.menuName ? 'active' : ''}
                                            onClick={() => setSelectedTab(tab.menuName)}
                                        >{tab.label}</Button>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    {/*  현재 설정 */}
                    <div className="info_box">
                        <span className="ico_box"><Icon icon='Sliders' size='2x' /></span>
                        <div className="txt_box">
                            <span className="text-muted">{t('현재 설정')}</span>
                            <p>{selectedCompany?.name}</p>
                            <span>{currentLang?.text}</span>
                            <span>{currentTheme?.text}</span>
                        </div>
                    </div>
                </div>
                <div className="right_area">
                    <div className="tab_content">
                        {selectedTab === 'company' && ( // 회사 변경
                            <div className="company_content">
                                {/* 현재회사 */}
                                <Card className='selected'>
                                    <p className="logo_box">
                                        <img
                                            src={`data:image/png;base64,${company?.logoBase64}`}
                                            alt={selectedCompany?.name}
                                        />
                                    </p>
                                    <div className="detail_box">
                                        <span className="flag">{t('현재 접속 중')}</span>
                                        <span>MetaTime-{selectedCompany?.id}</span>
                                        <strong>{selectedCompany?.name}</strong>
                                        <span>
                                            <Icon icon='People' size='lg' />
                                            {selectedCompany?.userCount}{t('명')}
                                        </span>
                                    </div>
                                    <span className="ico_box">
                                        <Icon icon='CheckCircleFill' size='3x' color='info' />
                                        <span>{t('현재 회사')}</span>
                                    </span>
                                </Card>

                                {/* 전환 가능한 회사 */}
                                <div className="company_list">
                                    <div className="top_box">
                                        <h3>{t('전환 가능한 회사')}</h3>
                                        <div className="search_box no_txt">
                                            <Label htmlFor='searchCompany' className='visually-hidden'>{t('회사 검색')}</Label>
                                            <Input
                                                type="text"
                                                id='searchCompany'
                                                placeholder={t('회사 검색')}
                                                value={searchText}
                                                onChange={(e) => {
                                                    setSearchText(e.target.value);
                                                }}
                                                onKeyDown={(e) => {
                                                    if(e.key === 'Enter'){
                                                        e.preventDefault();
                                                        setAppliedSearchText(searchText);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {filteredCompany.length > 0 ? (
                                        <ul>
                                            {filteredCompany.map((v) => {
                                                return(
                                                    <li key={v.id}>
                                                        <Card>
                                                            <Button
                                                                type='button'
                                                                className='btn_card'
                                                                onClick={() => {
                                                                    setIsSettingPopOpen(false);
                                                                    handleOnClickToEmployeeListPage(v);
                                                                }}
                                                            >
                                                                <span className="logo_box">
                                                                    <img
                                                                        src={`data:image/png;base64,${v?.logoBase64}`}
                                                                        alt={v?.name}
                                                                    />
                                                                </span>
                                                                <span className="detail_box">
                                                                    <span>MetaTime-{v?.id}</span>
                                                                    <strong>{v?.name}</strong>
                                                                    <span>
                                                                        <Icon icon='People' size='lg' />
                                                                        {v?.userCount}{t('명')}
                                                                    </span>
                                                                </span>
                                                                <span className="ico_box">
                                                                    <Icon icon='ChevronRight' size='3x' className='ico_arrow' />
                                                                </span>
                                                            </Button>
                                                        </Card>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    ) : (
                                        <div className="no_data">
                                            <div>
                                                <img src={imgNoData} alt="데이터 없음"/>
                                            </div>
                                            <p>{t('전환 가능한 회사가 없습니다.')}</p>
                                        </div>
                                    )}
                                </div>
                                {/* 대표 관리자 영역 */}
                                {user?.me?.roleName === '대표 관리자' && (
                                    <div className="main_admin_box">
                                        <span className="flag"><Icon icon='ShieldCheck' size="md" className='me-2' />{t('대표관리자 전용')}</span>
                                        <div className="mt-3">
                                            <Button
                                                isOutline
                                                color='info'
                                                className='me-2'
                                                onClick={() => {
                                                    setCompanyModal(true);
                                                }}
                                            >
                                                {t('신규 추가')}
                                            </Button>
                                            <Button
                                                isOutline
                                                color='info'
                                                onClick={() => {setCompanyModal2(true)}}
                                            >
                                                {t('합류코드를 통한 회사 참여')}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {selectedTab === 'background' && ( // 배경 이미지
                            <BackgroundSetContent isOpen={isSettingPopOpen} setIsOpen={setIsSettingPopOpen}/>
                        )}

                        {selectedTab === 'language' && ( // 언어
                            <div className="lang_content">
                                <h3>{t('메타타임에서 사용할 언어를 선택하세요.')}</h3>
                                <p className="h5 text-muted">{t('선택한 언어는 메뉴와 안내 문구에 즉시 적용됩니다.')}</p>
                                <Dropdown>
                                    <DropdownToggle hasIcon={false}>
                                        <Button
                                            className='btn_current'
                                            icon={currentLang?.icon}
                                        >
                                            {currentLang?.text}
                                            <span>{t('현재 언어')}</span>
                                            <Icon icon='ChevronDown' size='lg' className='btn_arrow' />
                                        </Button>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        isAlignmentEnd
                                        isCloseAfterLeave={false}
                                        data-tour='lang-selector-menu'
                                    >
                                        {Object.keys(LANG).map((i) => (
                                            <DropdownItem key={LANG[i].lng}>
                                                <Button
                                                    isDisable={lang === LANG[i].lng}
                                                    icon={LANG[i].icon}
                                                    onClick={() => {
                                                        changeLanguage(LANG[i].lng);
                                                        setIsSettingPopOpen(false);
                                                    }}
                                                >
                                                    {LANG[i].text}
                                                    {lang === LANG[i].lng &&
                                                        <Icon icon='Check' size='lg' className='btn_arrow' />
                                                    }
                                                </Button>
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        )}

                        {selectedTab === 'theme' && ( // 테마
                            <div className="theme_content">
                                <h3>{t('메타타임에서 사용할 테마를 선택하세요.')}</h3>
                                <p className="h5 text-muted">{t('선택한 테마는 즉시 적용됩니다.')}</p>
                                <Dropdown>
                                    <DropdownToggle hasIcon={false}>
                                        <Button
                                            className='btn_current'
                                            icon={currentTheme?.icon}
                                        >
                                            {currentTheme?.text}
                                            <span>{t('현재 테마')}</span>
                                            <Icon icon='ChevronDown' size='lg' className='btn_arrow' />
                                        </Button>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        isAlignmentEnd
                                        isCloseAfterLeave={false}
                                        data-tour='theme-selector-menu'
                                    >
                                        {Object.keys(THEME).map((i) => (
                                            <DropdownItem key={THEME[i].key}>
                                                <Button
                                                    isDisable={darkModeStatus === (THEME[i].key === 'dark')}
                                                    icon={THEME[i].icon}
                                                    onClick={() => {
                                                        changeTheme(THEME[i].key);
                                                        setIsSettingPopOpen(false);
                                                    }}
                                                >
                                                    {THEME[i].text}
                                                    {darkModeStatus === (THEME[i].key === 'dark') &&
                                                        <Icon icon='Check' size='lg' className='btn_arrow' />
                                                    }
                                                </Button>
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                </div>
            </ModalBody>
        </Modal>

        {/* ************* 설정 모달 속 모달 ************* */}
        {/* 회사 변경 > 신규추가 */}
        <AddCompanyModal
            isModal={companyModal}
            setIsModal={setCompanyModal}
            onCreated={getCompany}
        />
        {/* 회사 변경 > 합류 코드를 통한 회사 참여 */}
        <JoinCompanyModal
            isModal={companyModal2}
            setIsModal={setCompanyModal2}
            onCreated={getCompany}
        />
        </>
    );
};

export default SettingModal;
